// @flow
import * as React from 'react';
import {useLocation} from 'docs/data';
import {Executable} from './_executable';
import {Pages, parsePath, search} from '../helpers/executables/docs_navtree';

// React component with hook to push the new location and redirect
const ChangeDirectory = (props: {currentPath: string, command: string}) => {
  const {currentPath, command} = props;
  const {pushLocation} = useLocation();

  let page = null;
  React.useEffect(() => {
    if (page) {
      pushLocation(page.route);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const currentPage = search(currentPath, Pages());
  if (currentPage == null) {
    return <p>Error, something went wrong.</p>;
  }

  page = parsePath(command, currentPage);
  if (page === null) {
    return <p>page not found: {command}</p>;
  }

  return <pre />;
};

export class cd extends Executable {
  commandName(): string {
    return 'cd';
  }

  shortHelp(): string {
    return 'navigates to other pages on the docs site';
  }

  help(): React.Node {
    this.setAllowInput(true);

    return (
      <>
        <p>cd (change docs) - navigates to other pages on the docs site.</p>
        <br />
        <p>
          cd changes docs based on the relative path of the doc from the
          <br />
          navigation structure on the left. The paths themselves can either be
          <br />
          the page's title or the slug representation (where the slug is all
          <br />
          lowercase and dashes instead of spaces).
        </p>
        <br />
        <p>Example:</p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;cd developers/developer-tools/stripe-cli (from
          the home page)
        </p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;cd ../webhooks (from the Stripe CLI page)</p>
      </>
    );
  }

  run() {
    // cd does not work with 0 arguments (unlike ls) so display the
    // help text
    if (this.command.structuredArgs.length === 0) {
      this.setAllowInput(true);

      return <p>{this.help()}</p>;
    }

    // no flags support
    if (this.command.structuredFlags.length !== 0) {
      this.setAllowInput(true);
      return (
        <p>
          cd does not take any flags, given:{' '}
          {this.command.structuredFlags.join(' ')}
        </p>
      );
    }

    // This command support changing directories by page titles which
    // includes spaces. It's weird but may be a little more obvious
    // since it's represented in the left nav
    let command = this.command.structuredArgs.join(' ');

    // Replace the last backslash if given, the page lookup won't recognize
    // pages that end with /
    command = command.replace(/\/$/, '');

    // Replace the very first backslash with a ~, which internally represents
    // starting from the root of the navtree. ~/home and /home are behaviorally
    // identical but it's easier for us to always represent the latter with
    // a ~
    command = command.replace(/^\/home/, '~');
    command = command.replace(/^\//, '~');

    this.setAllowInput(true);
    return (
      <ChangeDirectory
        currentPath={window.location.pathname}
        command={command}
      />
    );
  }
}
